import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=c620a42e&scoped=true&"
import script from "./LoginBox.vue?vue&type=script&lang=js&"
export * from "./LoginBox.vue?vue&type=script&lang=js&"
import style0 from "./LoginBox.vue?vue&type=style&index=0&id=c620a42e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c620a42e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c620a42e')) {
      api.createRecord('c620a42e', component.options)
    } else {
      api.reload('c620a42e', component.options)
    }
    module.hot.accept("./LoginBox.vue?vue&type=template&id=c620a42e&scoped=true&", function () {
      api.rerender('c620a42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/LoginBox.vue"
export default component.exports